import {ISelectOption} from '../../_widget-library/fields/single-select/single-select.component';
import {FlagService} from '../../flag/services/flag.service';

export class QueryableProperty {
  name: string;
  type: string;
  objectType: string;
  displayName: string;
  defaultValue: any | undefined;
  expanded: boolean = false;
  visuals: any | undefined;
  disabled: boolean = false;

  // tslint:disable-next-line:no-unnecessary-initializer
  constructor(name: string, displayName: string, type: string, expanded: boolean = false, visuals: any = undefined, defaultValue: any = undefined, disable: boolean = false) {
    this.name = name;
    this.displayName = displayName;
    this.type = type;
    this.expanded = expanded;
    this.visuals = visuals;
    this.defaultValue = defaultValue;
    this.disabled = disable;
  }
}

export class QueryableRow extends QueryableProperty {
  properties: QueryableProperty[];
  visuals: any | undefined;
  // tslint:disable-next-line:no-unnecessary-initializer
  constructor(properties: QueryableProperty[], visuals: any = undefined, defaultValue: any = undefined) {
    super('', '', 'row');
    this.properties = properties;
    this.visuals = visuals;
    this.defaultValue = defaultValue;
  }
}

export class QueryableSeparator extends QueryableProperty {
  // tslint:disable-next-line:no-unnecessary-initializer
  constructor() {
    super('', '', 'separator');
  }
}

export class QueryableEnum extends QueryableProperty {
  possibleValues: ISelectOption[];

  // tslint:disable-next-line:no-unnecessary-initializer
  constructor(name: string, objectType: string, displayName: string, type: string, expanded: boolean = false, visuals: any = undefined, possibleValues: ISelectOption[], defaultValue: ISelectOption[] = undefined) {
    super(name, displayName, type, expanded, visuals);
    this.possibleValues = possibleValues;
    this.objectType = objectType;
    this.defaultValue = defaultValue;
  }
}

export class QueryableFlag extends QueryableEnum {
  // tslint:disable-next-line:no-unnecessary-initializer
  constructor(flagService: FlagService, name: string, objectType: string, displayName: string, expanded: boolean = false, visuals: any = undefined) {
    super(name, objectType, displayName, 'flag', expanded, visuals, [
      {name: 'flag', value: 0, icon: 'fa-flag', color: flagService.getColor(0)},
      {name: 'flag', value: 1, icon: 'fa-flag', color: flagService.getColor(1)},
      {name: 'flag', value: 2, icon: 'fa-flag', color: flagService.getColor(2)},
      {name: 'flag', value: 3, icon: 'fa-flag', color: flagService.getColor(3)},
      {name: 'flag', value: 4, icon: 'fa-flag', color: flagService.getColor(4)},
      {name: 'flag', value: 5, icon: 'fa-flag', color: flagService.getColor(5)},
      {name: 'ban', value: -1, icon: 'fa-ban', color: 'rgb(168, 0, 0)'},
    ]);
  }
}
